// extracted by mini-css-extract-plugin
module.exports = {"flex":"Advantages_flex__h1-JH","flexItem":"Advantages_flexItem__sq47s","title":"Advantages_title__2o5a1"};